// extracted by mini-css-extract-plugin
export default {"tabSelectorContainer":"tabSelectorContainer-heOHi","tabSelector":"tabSelector-smEV8","btnTab":"btnTab-Tauqw","activeTab":"activeTab-mVSN7"};